module.exports = __webpack_public_path__ + "img/placeholder.d928bb28.jpg";